import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * UAE Emirates ID generator following Single Responsibility Principle
 */
export class ArGenerator extends BaseGenerator {
  generate() {
    // UAE Emirates ID always starts with 784 (country code)
    const countryCode = '784';
    
    // Generate year (4 digits)
    const year = this.randomInt(1950, 2010);
    
    // Generate sequence (7 digits)
    const sequence = this.randomDigits(7);
    
    // Calculate Luhn check digit
    const digits = year + sequence;
    let sum = 0;
    let alternate = false;

    for (let i = digits.length - 1; i >= 0; i--) {
      let n = parseInt(digits[i]);
      
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      
      sum += n;
      alternate = !alternate;
    }

    const checkDigit = (10 - (sum % 10)) % 10;
    
    return `${countryCode}-${year}-${sequence}-${checkDigit}`;
  }
}